import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'

const Paragraph = ({ children, variant, invert, center, centerWhen, bold, noMargin }) => (
  <p
    className={cx({
      paragraph: true,
      [`paragraph--${variant}`]: variant,
      'paragraph--invert': invert,
      'paragraph--bold': bold,
      'paragraph--noMargin': noMargin,
      'paragraph--center': center,
      'paragraph→sm--center': centerWhen?.sm,
      'paragraph→md--center': centerWhen?.md,
      'paragraph→lg--center': centerWhen?.lg,
      'paragraph→hg--center': centerWhen?.hg,
      'paragraph→gt--center': centerWhen?.gt
    })}
  >
    {children}
  </p>
)

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'small', 'hero']),
  invert: PropTypes.bool,
  center: PropTypes.bool,
  centerWhen: PropTypes.object,
  bold: PropTypes.bool,
  noMargin: PropTypes.bool
}

Paragraph.defaultProps = {
  variant: 'default',
  invert: false,
  center: false,
  bold: false,
  noMargin: false,
  centerWhen: {}
}

export default Paragraph
